import $ from 'jquery';
import { throttle } from './utils';
import iScroll from 'iscroll';

export const handleListAnimation = () => {
  const $wrap = $('#list');
  if ($wrap.length === 0) return;

  let scroller = null;
  const $items = $wrap.find('li');
  const $headLinks = $wrap.find('.list--item-headline');

  function handleChangeCover($headline) {
    if ($headline.length > 0) {
      $items.removeClass('on');

      const item = $headline.parents('li');
      item.addClass('on');
    }
  }

  function setCustomListStyle(text = '') {
    const $listStyle = $('#listStyle');
    if ($listStyle && $listStyle.length > 0) {
      $listStyle.text(text);
    } else {
      $('head').append(`<style id="listStyle">${text}</style>`);
    }
  }

  function isMobile() {
    return window.innerWidth < 768;
  }

  function handleChangeListWidth() {
    const winW = window.innerWidth;
    const listW = $('.list-wrap').width();

    const nextWidth = winW > listW ? winW - (80 * ($items.length - 1)) : 720;

    if (isMobile() && scroller) {
      scroller.destroy();
      scroller = null;
    } else if (!scroller) {
      initHScroll();
    }

    setCustomListStyle(`
      @media (min-width: 768px) {
        .list--item.on .list--item-inner,
        .list--item.on .list--item-inner .list--item-link { width: ${nextWidth}px; }
      }
    `);
  }

  function initHScroll() {
    if (isMobile()) return;
    if (!scroller) {
      scroller = new iScroll('#list', {
        mouseWheel: true,
        scrollbars: false,
        scrollX: true,
        scrollY: true,
        disableMouse: true,
        disablePointer: true,
      });
    }
  }

  function init() {


    const $prevHeadline = location.hash ? $wrap.find(`.list--item-headline[href="${location.hash}"]`) : '';
    handleChangeCover($prevHeadline.length ? $prevHeadline : $headLinks.first());
    handleChangeListWidth();
    initHScroll();

    window.addEventListener('hashchange', function () {
      if (location.hash) {
        const $prevHeadline = $wrap.find(`.list--item-headline[href="${location.hash}"]`);
        handleChangeCover($prevHeadline);
      }
    })

    window.addEventListener('resize', throttle(handleChangeListWidth));
  }

  init();
}
